<mat-sidenav #snav (click)="snav.close();" [autoFocus]="false" mode="push">

  <mat-nav-list>

    <a [routerLinkActiveOptions]="{exact: true}" mat-list-item routerLink="/" routerLinkActive="active-link">
      <i class="material-icons" style="vertical-align: middle;">home</i>
      Startseite
    </a>

    <a *ngIf="isAuth" mat-list-item routerLink="/community" routerLinkActive="active-link">
      <i class="material-icons" style="vertical-align: middle;">people</i>
      Meine Community
    </a>
    <a *ngIf="isAuth" mat-list-item routerLink="/meine-strombilanz" routerLinkActive="active-link">
      <i class="material-icons" style="vertical-align: middle;">insert_chart_outlined</i>
      Meine Strombilanz
    </a>
    <a (click)="logout()" *ngIf="isAuth" mat-list-item style="cursor: pointer">
      <i class="material-icons" style="vertical-align: middle;">power_settings_new</i>
      Abmelden
    </a>
    <a (click)="account()" *ngIf="isAuth" mat-list-item style="cursor: pointer">
      <i (click)="track()" class="material-icons" style="vertical-align: middle;">account_circle</i>
      Mein Account
    </a>
    <a (click)="login()" *ngIf="!isAuth" mat-list-item style="cursor: pointer">
      <i class="material-icons" style="vertical-align: middle;">power_settings_new</i>
      Anmelden
    </a>


    <br/>
    <a mat-list-item routerLink="/kontakt" routerLinkActive="active-link">
      <i class="material-icons" style="vertical-align: middle;">mail_outline</i>
      Kontakt
    </a>
    <a mat-list-item routerLink="/impressum" routerLinkActive="active-link">
      <i class="material-icons" style="vertical-align: middle;">info</i>
      Impressum
    </a>
    <a mat-list-item routerLink="/datenschutz" routerLinkActive="active-link">
      <i class="material-icons" style="vertical-align: middle;">assignment</i>
      Datenschutz
    </a>
    <br/>
    <mat-list-item>
      © Kisters AG {{ today | date:'y' }}
    </mat-list-item>
  </mat-nav-list>


</mat-sidenav>

<div class="header">
  <div class="wrapper" fxLayout="row" fxLayout.xs="column">
    <div fxFlex="50%" fxLayoutAlign.xs="center center">
      <a (click)="snav.toggle()" fxHide.xs="false" fxLayoutAlign.xs="left center"
         fxShow="false" mat-icon-button style="position: absolute; left:10px; color: white;">
        <mat-icon style="font-size: 30px;">menu</mat-icon>
      </a>
      <a class="logo" routerLink="/">

        <img [src]="this.url + '/tenant/' + tenant.getId() +  '/logo-image'" alt="Logo"/>
      </a>
    </div>


    <div fxFlex="50%" fxHide.xs="true" fxLayoutAlign="end center" fxShow="true">
      <mat-card class="usernavi" style="padding:5px;">
        <div style="float:left; padding:5px 10px 10px 0">

          <ul *ngIf="isAuth">
            <li style="font-weight: bold;">
              Hallo {{userService.getFullname()}}
            </li>
            <li *ngIf="userService.hasRole(accessRolesEnum.USER_ROLE_VIEW_COMMUNITY_DATA)" style="margin-top:5px;">
              <a routerLink="/community" routerLinkActive="active-link">
                <i class="material-icons" style="vertical-align: middle;">people</i> Meine Community
              </a>
            </li>
            <li *ngIf="userService.hasRole(accessRolesEnum.USER_ROLE_VIEW_CUSTOMER_DATA)" style="margin-top:5px;">
              <a routerLink="/meine-strombilanz" routerLinkActive="active-link">
                <i class="material-icons" style="vertical-align: middle;">insert_chart_outlined</i> Meine Strombilanz
              </a>
            </li>
            <li style="margin-top:10px;">
              <a (click)="logout()" style="cursor: pointer">
                <i class="material-icons" style="vertical-align: middle;">power_settings_new</i> Abmelden
              </a>
            </li>
            <li style="margin-top:10px;">
              <a (click)="account()" style="cursor: pointer">
                <i class="material-icons" style="vertical-align: middle;">account_circle</i> Mein Account
              </a>
            </li>
          </ul>

          <ul *ngIf="!isAuth">
            <li style="margin-top:10px;">
              <a (click)="login()" style="cursor: pointer">
                <i class="material-icons" style="vertical-align: middle;">power_settings_new</i> Anmelden
              </a>
            </li>
          </ul>

        </div>
      </mat-card>
    </div>
  </div>
</div>
